import * as types from './mutation-types'

export default {
  [types.LOAD_PROGRAMS](state, data) {
    state.programs = data.programs
  },
  [types.ADD_PROGRAM](state, data) {
    state.programs.push(data.program)
  },
  [types.SET_CURRENT_PROGRAM](state, data) {
    state.currentProgram = data.program
  },
  [types.UPDATE_PROGRAM](state, data) {
    state.programs = state.programs.map((program) => program.id === data.program.id ? data.program : program)
    if (state.currentProgram && state.currentProgram.id === data.program.id) {
      state.currentProgram = data.program
    }
  },
  [types.REMOVE_PROGRAM](state, programId) {
    state.programs = state.programs.filter((program) => program.id !== programId)
  },
  [types.LOAD_EARNING_TYPES](state, data) {
    state.earningTypes = data
  },
  [types.LOAD_REWARD_TYPES](state, data) {
    state.rewardTypes = data
  },
  [types.LOAD_SIMPLE_PRODUCTS](state, data) {
    state.simpleProducts = data.products
  },
  [types.SET_POS_MEMBERSHIP](state, data) {
    state.posMember = data.member
    state.posAvailableRewards = data.available_rewards || []
  },
  [types.CLEAR_POS_MEMBERSHIP](state) {
    state.posMember = null
    state.posAvailableRewards = []
  },
  [types.LOAD_MY_SHOPS](state, data) {
    state.myShops = data.shops
  },
  [types.LOAD_MEMBERS](state, data) {
    state.members = data.members
    state.memberStats = data.stats
  },
  [types.SET_CURRENT_MEMBER](state, data) {
    state.currentMember = data.member
    state.currentMemberTransactions = data.transactions
  },
}
